import React from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { Button } from './Button';
interface CompleteWorkoutModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}
export function CompleteWorkoutModal({
  onConfirm,
  onCancel
}: CompleteWorkoutModalProps) {
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-102">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in zoom-in-95 duration-200 relative" data-id="element-103">
        <button onClick={onCancel} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-104">
          <X size={20} data-id="element-105" />
        </button>

        <div className="w-12 h-12 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-5 mx-auto" data-id="element-106">
          <CheckCircle2 size={28} data-id="element-107" />
        </div>

        <div className="text-center mb-8" data-id="element-108">
          <h2 className="text-2xl font-extrabold text-slate-800 mb-2" data-id="element-109">
            Complete this workout?
          </h2>
          <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-110">
            Your completed workout will be added to your history and used in
            your exercise progress.
          </p>
        </div>

        <div className="space-y-3" data-id="element-111">
          <Button variant="primary" fullWidth onClick={onConfirm} data-id="element-112">
            Yes, I did it
          </Button>
          <Button variant="outline" fullWidth onClick={onCancel} data-id="element-113">
            Not yet
          </Button>
        </div>
      </div>
    </div>;
}